export default __webpack_public_path__ + "static/media/jornal1.ce278f07.png";